import constants from '../constants';
import { fetchCards } from './cards';

export const setTimelineDefaultFilters = payload => (
  (dispatch) => {
    dispatch({ type: constants.SET_TIMELINE_DEFAULT_FILTERS, payload });
    dispatch(fetchCards());
  }
);
